
"use strict";
import {http} from '../../core';
const RequestService = http.create();

export default {
    cmdbList (params) {
        return RequestService.post("cmdb/list", params)
    },
    // 删除配置项关系
    cmdbRelationshipDelete(params) { 
        return  RequestService.post('cmdb/relationship/delete', params)
    },
      // 根据父分类id,获取所有子分类
      childrenList: function(params) {
        return  RequestService.get('category/children/list/all', params)
    },
     // 配置项列表
     cmdbLlist: function(params) {
        return  RequestService.get('cmdb/list', params)
    },
    // 删除配置项
    cmdbdDelete: function(params) {
        return  RequestService.post('cmdb/delete', params)
    },
    // 按类型获取子分类
    typeList: function(params) {
        return  RequestService.get('category/type/list/all', params)
    },
}